const isWorkListImage = (image) => image?.origin === 'worklist';

export default isWorkListImage;
export { isWorkListImage };
